import { FC, ReactNode, useContext } from 'react';

import { GlobalContext } from '@/pages/_app';

interface Props {
	href: string;
	rel?: string;
	children: ReactNode | ReactNode[];
}

const LocalizedLink: FC<Props> = ({ href, rel, children }) => {
	const { lang } = useContext(GlobalContext);
	const isHash = href?.startsWith('#');
	const isOuterLink =
		href?.startsWith('http') || href?.includes('back-to-school');
	const includesLang = href?.startsWith('/' + lang);

	return (
		<a
			target={isOuterLink ? '_blank' : undefined}
			href={isHash || isOuterLink || includesLang ? href : '/' + lang + href}
			rel={isOuterLink ? 'noopener noreferrer' : (rel ?? undefined)}
		>
			{children}
		</a>
	);
};

export default LocalizedLink;
